import { useContext, useEffect, useState } from 'react';
import { useLoadingState } from '../../hooks/useLoader';
import { AuthContext } from '../../contexts/AuthContext';
import StatsCardGreenpill from '../../ui/StatsCardGreenpill';
import { getgreenpillLeaderboard } from '../../apis/geenpills/getLandscapes';
import { GreenpillLeaderboardTable } from './GreenpillLeaderboardTable';
import { formatNumber } from '../../helpers/formatNumber';
import TrophyIcon from '../../assets/icons/TrophyIcon';

const GreenpillLeaderboard = () => {
    const { loading, startLoading, stopLoading } = useLoadingState();
    const { state } = useContext(AuthContext);
    const [currentPage, setCurrentPage] = useState(1);
    const {
        loading: gettingMyDetails,
        startLoading: startGettingMyDetails,
        stopLoading: stopGettingMyDetails,
    } = useLoadingState();
    // const [myDetails, setMyDetails] = useState({});
    const [totalEntries, setTotalEntries] = useState(0);

    const [leaderboardData, setLeaderboardData] = useState([]);
    const [entriesPerPage, setEntriesPerPage] = useState(10);

    const entriesHandler = (val) => {
        setEntriesPerPage(val);
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                startLoading();
                const response3 = await getgreenpillLeaderboard(currentPage, entriesPerPage);
                console.log('aaya kya response 3', response3);
                setLeaderboardData(response3?.data);
                setTotalEntries(response3?.entryCount);
            } catch (error) {
                console.error(error, 'error');
            } finally {
                stopLoading();
            }
        };
        fetchData();
    }, [currentPage, entriesPerPage]);

    // const myInfo = leaderboardData?.find((leader) => leader?.evmAddress === state?.citizen?.evmAddress);

    // const myLeaderDetails =
    //     leaderboardData?.find((leader) => leader?.evmAddress === state?.citizen?.evmAddress) || state?.citizen;

    return (
        <div
            style={{
                // backgroundImage: `url(${Bg})`,
                background: 'black',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
            }}
            className="bg-fixed min-h-screen"
        >
            <div className="   pb-9">
                <div className=" ">
                    <h1
                        className="text-6xl font-bold text-textHeading "
                        style={{
                            textShadow: '0px 0px 11.8px rgba(255, 255, 255, 0.59)',
                        }}
                    >
                        Leaderboard
                    </h1>
                    <h6 className="text-sm text-textSupportHeading mt-1">
                        More of the network you use, more impact points you earn. IPs are used for all loyalty and
                        incentive programs within the network
                    </h6>
                </div>
                <div className=" flex items-center gap-3 my-5">
                    {/* <StatsCardGreenpill
                        label="Total funded"
                        symbol={<p className="text-4xl font-medium ">$</p>}
                        stats={myDetails?.amountFundedInUSD?.toFixed(2)}
                        loading={gettingMyDetails}
                    /> */}
                    <StatsCardGreenpill
                        label="IP unlocked till now"
                        symbol={<TrophyIcon />}
                        // stats={myDetails?.impactPointsEarned ? formatNumber(myDetails?.impactPointsEarned) : 0}
                        stats={0}
                        loading={gettingMyDetails}
                    />
                    <StatsCardGreenpill
                        label="My Rank"
                        symbol={<p className="text-4xl font-medium ">#</p>}
                        // stats={myDetails?.rank}
                        stats={0}
                        loading={gettingMyDetails}
                    />
                </div>

                <div>
                    <GreenpillLeaderboardTable
                        leaderboardData={[...leaderboardData]}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        loading={loading}
                        totalEntries={totalEntries}
                        entriesPerPage={entriesPerPage}
                        entriesHandler={entriesHandler}
                        color="fill-[#326F58]"
                    />
                </div>
            </div>
        </div>
    );
};

export default GreenpillLeaderboard;
